import _ from 'lodash';

/**
 * Normalises a study friendly id typed into search so leading zeros do not break the query. Returns an empty string for an empty value and otherwise round-trips the value through Number and back to a string.
 *
 * @param studyFid - Study friendly id entered in the search box.
 * @returns Numeric study id as a string, or an empty string.
 */
const searchStudyFidFormatter = (studyFid: any) => {
  if (_.isEmpty(studyFid)) {
    return '';
  }

  return Number(studyFid).toString();
};

export { searchStudyFidFormatter };
